<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #484a4d;
  /* background:  #b6bbbb21; */
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.el-table__row .el-button {
  margin-top: 10px;
}

.query-param-span{
  display:inline-block;
  margin: 5px;
}

.query-param-btn{
  margin: 5px;
}

.query-param-add-btn{
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue